module.exports = __webpack_public_path__ + "static/media/logo.2e5f201d.svg";